import { Form } from 'factorial-form'

class Password extends Form {
  constructor(values: {}) {
    super(values, {
      current_password: 'string',
      password: 'string',
    })
  }
}

export default Password
